import { toast } from "sonner";

export const readJ = async (r) => { try { return await r.json(); } catch { return {}; } };

export const zoomApi = (authFetch) => ({
  get: async (path) => { const r = await authFetch(path); const d = await readJ(r); if (!r.ok) throw new Error(d.detail || "Request failed"); return d; },
  send: async (path, method, body) => { const r = await authFetch(path, { method, ...(body !== undefined ? { body: JSON.stringify(body) } : {}) }); const d = await readJ(r); if (!r.ok) throw new Error(typeof d.detail === "string" ? d.detail : "Request failed"); return d; },
  download: async (path, filename) => {
    try {
      const r = await authFetch(path);
      if (!r.ok) throw new Error((await readJ(r)).detail || "Export failed");
      const url = URL.createObjectURL(await r.blob());
      const a = document.createElement("a"); a.href = url; a.download = filename; document.body.appendChild(a); a.click(); a.remove();
      setTimeout(() => URL.revokeObjectURL(url), 5000);
    } catch (e) { toast.error(e.message); }
  },
});

export const fmtIST = (iso, opts = {}) => (iso ? new Date(iso).toLocaleString("en-IN", { timeZone: "Asia/Kolkata", day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit", ...opts }) : "—");
export const fmtDate = (d) => (d ? new Date(d + "T00:00:00").toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" }) : "—");
export const STATUS = { synced: "bg-emerald-100 text-emerald-800", live: "bg-sky-100 text-sky-800", ended: "bg-amber-100 text-amber-800", error: "bg-rose-100 text-rose-800" };
export const qs = (o) => Object.entries(o).filter(([, v]) => v !== "" && v !== undefined && v !== null).map(([k, v]) => `${k}=${encodeURIComponent(v)}`).join("&");
